export enum ERQualType {
	Tests = '1',
	Qualification = '2'
}

export enum ERStudentType {
	Domestic = 1,
	International = 2
}